module.exports = __webpack_public_path__ + "img/sphc.888cca2e.png";